import { SUBJECT_LIBRARY_TAB_SLUG } from '@yandex-int/k-common/typings';
import { getExperimentTestId } from 'platform-components';
import { getMe } from 'platform-components/src/components/user/selectors';
import { InjectedProps as WithRouterPathHOC, withRouterPath } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import qs from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';

import { getCurrentClass, getHasNoActiveTeams } from 'common.components/user/selectors';
import * as themeSelectors from 'store/themes/selectors';

import { ReduxTeacherStore } from '../../typings';
import { CalendarPlan } from '../library.calendar-plan.new/calendar-plan';
import { CourseContainerList } from '../library.course-container-list/course-container-list';
import { getCurrentShowcaseSlug, getCurrentSubjectPageSlug } from '../library.store/selectors';

import TabShowcase from './__showcase/tab-content__showcase';

interface HOCProps extends WithRouterPathHOC {}

type StoreProps = ReturnType<typeof mapStateToProps>;

interface Props extends HOCProps, StoreProps {}

export class LibraryTabContent extends React.Component<Props> {
    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };

    componentDidMount() {
        const { me, subject, grade, testId, currentShowcaseSlug, currentSubjectPageSlug, hasNoTeams } = this.props;

        ym('reachGoal', 'teacher_vitrina_visit', {
            teacher_id: me?.id,
            subject_slug: subject,
            team_level: grade,
            test_id: testId,
            general_showcase_slug: currentShowcaseSlug,
            subject_page_showcase_slug: currentSubjectPageSlug,
        });

        if (hasNoTeams) {
            ym('reachGoal', 'teacher_main_subject_visit_without_team', { user_id: me?.id || null });
        }

        this.redirectToLibrarySubjectTheme();
    }

    componentDidUpdate(prevProps: Props) {
        const {
            firstThemeId: prevFirstThemeId,
            match: {
                params: { tabSlug: prevTabSlug },
            },
        } = prevProps;
        const {
            firstThemeId,
            match: {
                params: { tabSlug },
            },
        } = this.props;

        if ((tabSlug && prevTabSlug !== tabSlug) || prevFirstThemeId !== firstThemeId) {
            this.redirectToLibrarySubjectTheme();
        }
    }
    context!: React.ContextType<React.Context<{ staticUrls: Record<string, string> }>>;

    redirectToLibrarySubjectTheme = () => {
        const {
            firstThemeId,
            getRouterPath,
            history,
            location: { search },
            match: {
                params: { tabSlug, classId },
            },
        } = this.props;
        const { staticUrls } = this.context;

        if (tabSlug === SUBJECT_LIBRARY_TAB_SLUG.MAIN && firstThemeId) {
            const path = classId ? staticUrls.labLibrarySubjectTheme : staticUrls.deepLabTheme;
            history.replace(`${getRouterPath(path, { themeId: firstThemeId })}${search}`);
        }
    };

    render() {
        const {
            match: {
                params: { tabSlug },
            },
            grade,
        } = this.props;

        if (tabSlug === SUBJECT_LIBRARY_TAB_SLUG.CONTAINER) {
            return <CourseContainerList />;
        }

        if (tabSlug === SUBJECT_LIBRARY_TAB_SLUG.MAIN) {
            return <TabShowcase grade={grade} />;
        }

        return <CalendarPlan />;
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: HOCProps) => {
    const {
        location: { search },
        match: {
            params: { classId, subject },
        },
    } = ownProps;
    const query = qs.parse(search);
    const currentClass = getCurrentClass(storeState, { classId });
    const grade = currentClass?.level || Number(query.grade);

    return {
        subject,
        grade,
        me: getMe(storeState),
        firstThemeId: themeSelectors.getFirstPlainThemeId(storeState, { subject, grade }),
        hasNoTeams: getHasNoActiveTeams(storeState),
        testId: getExperimentTestId(storeState),
        currentShowcaseSlug: getCurrentShowcaseSlug(storeState),
        // @ts-ignore
        currentSubjectPageSlug: getCurrentSubjectPageSlug(storeState, { subject, classId, grade }),
    };
};

export default withRouterPath(connect(mapStateToProps)(LibraryTabContent));
